import { api } from "./api";

export const SLOT_LABEL = { original: "Original", client: "Client copy" };

export function fmtBytes(n) {
  if (n === null || n === undefined) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function latestRev(quote, slot) {
  const revs = quote?.files?.[slot] || [];
  return revs.length ? revs[revs.length - 1] : null;
}

export function quoteFilePath(tenderId, quoteId, slot, rev) {
  return `/tenders/${tenderId}/subby-quotes/${quoteId}/files/${slot}/${rev}`;
}

export async function downloadQuoteFile(tenderId, quoteId, slot, rev, filename) {
  const r = await api.get(quoteFilePath(tenderId, quoteId, slot, rev), { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `${slot}-r${rev}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function isPdfFile(file) {
  return !!file && (file.type === "application/pdf" || /\.pdf$/i.test(file.name || ""));
}

export const MAX_PDF_BYTES = 10 * 1024 * 1024;
